import React, { Component } from "react";
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome'
import { Button, Modal, PageHeader, FormGroup, InputGroup, FormControl, ListGroup, ListGroupItem } from "react-bootstrap";
import { invokeApig }              from '../../libs/awsLib';
import { Link, Routes }            from 'react-router-dom'
import LoaderButton                from "../../components/LoaderButton";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import SortDropdownClientDocument  from "../../components/utils/SortDropdownClientDocument";
import RenderLander                from "../../components/utils/RenderLander";
import { handleGoToURL}            from "../../utils/URL";
import { getFiletypeIcon }         from "../../utils/Icons"
import uniqueId                    from 'lodash/uniqueId';
import { s3Delete }                from "../../libs/awsLib";
import { Colors }                  from "../../utils/Colors";
import ModalAlert                  from "../../components/modal/ModalAlert";
import { invokeGetClientDocumentsListAll, invokeGetDocumentsListAll, invokeSetDeleteDocument } from "../../utils/AwsInvoke";
import "../../css/document/DocumentListAll.css";
import "../../css/form/Btn.css";
import "../../css/modal/ModalBasics.css";
import checkmark_green from '../../images/utils/checkmark_green.png';
import checkmark_gray  from '../../images/utils/checkmark_gray.png';

// uuidv1() = timestamp | uuidv4() = rnadom
const uuidv1 = require('uuid/v1');

export default class DocumentAllClientList extends Component {
    constructor(props) {
        super(props);

        var search_term = `${this.props.match.params.search_term}`;
        if(search_term === "&") search_term = "";

        this.state = {
              isLoading: true, // default is true
              numberOfRows: 100,
              clientId: `${this.props.match.params.client_id}`,
              clientIdDocToDelete: '',
              company_id: "",
              searchMsg: "",
              searchTerm: search_term,
              showLoadingBar:"none",
              sortBy: 4, // default sort by Date Desc
              pageOverlay: "none",
              showDeleteConfirmWin: false,

              modalAlertTitleText: "",
              modalAlertBodyText:  "",
              showModalAlert:      false, // true | false
              alertObject:         {},
              alertAction:         "",
        };
    }

    componentDidMount() {
        var that = this;
        if (!this.props.isAuthenticated) {
            return;
        }

        try {

            this.getDocumentList();
        } catch (e) {
            alert(e);
        }
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    getDocumentList = async event => {

        var number_of_rows = this.state.numberOfRows;
        this.setState({
            isLoading:false,
            showLoadingBar: "inline",
            showDeleteConfirmWin: false,
        })

        //// If user searched for a Document and then hits the back button,
        //// take the user back to the search results page with the search term
        var search_term = this.state.searchTerm;
        var sort_by     = this.state.sortBy;
        var company_id  = this.props.globalCompanyId;
        var client_id   = this.state.clientId;

        /* if(search_term != "" && search_term != "&") {
            //console.log("GO SEARCH!");
        } else search_term = ""; */

        if(search_term === "&") search_term = "";
        if(client_id === "&") client_id = "%"; // update value to reflect to search all clients in db

        console.log("sort_by: " + sort_by)
        console.log("search_term: " + search_term);
        console.log("client_id: " + client_id);

        //const results = await invokeGetClientDocumentsListAll(client_id, company_id, number_of_rows, sort_by, search_term);
        const results = await invokeGetDocumentsListAll(client_id, number_of_rows, sort_by, search_term);

        if(results) {
            console.log("results: " + results);
            this.setState({
                documents: results,
                isLoading: false,
                showLoadingBar: "none"
            });
        } else
            this.setState({ isLoading: false, showLoadingBar: "none" })
    }

    clearSearchField = () => {
        // RESET URL
        this.props.history.replace("/document/listAllDocuments/&/&")

        this.setState({
            searchTerm: "", // reset search term if resetting document list
        })
    }

    searchDocuments = async () => {
        var search_term = this.state.searchTerm;

        if(this.searchInput != undefined) {
            search_term = this.searchInput.value;

            if(search_term.length === 0) search_term = "&";

            this.props.history.replace("/document/listAllDocuments/&/"+search_term)

            //// RESET Search Textfield
            if(search_term === "&") {
                this.setState({
                    searchTerm: "", // reset search term if resetting document list
                    searchMsg: ""   // clear search message
                }, function () {
                    this.getDocumentList();
                })
                return
            }
        }

        var client_id      = this.state.client_id;

        var company_id = this.props.globalCompanyId;

        var sort_by        = this.state.sortBy;
        var number_of_rows = this.state.numberOfRows;

        if(client_id === "&") client_id = "%"; // update value to reflect to search all clients in db

        const results = await invokeGetDocumentsListAll(client_id, number_of_rows, sort_by, search_term);// search_term.toLowerCase()

        if(results) {
            console.log("results: " + results);
            this.setState({
                documents: results,
                searchTerm: search_term,
                searchMsg: "You have "+results.search_lgth+ " results when searching for '" + search_term + "'.",
                isLoading: false,
                showLoadingBar: "none"
            });
        } else {
            this.setState({
                isLoading: false,
                showLoadingBar: "none"
            });
        }
    }

    sortResults = (sort) => {
        // Sort: 1 = Filename: Asc | 2 = Filename: Desc | 3 = Filetype: Asc | 4 = Filetype: Desc
        console.log("Sort: " + sort);
        this.setState({
            sortBy: sort,
            documents: null // reset documents object otherwise the documents list will re-render multiple times
        }, function(){
            this.getDocumentList();
        })
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchDocuments();
    }

    handlePreURL = (e, that, document_id, client_id) => {
        //console.log("1. client_id: " + client_id);
        var tmp_client_id = this.state.clientId;
        // If Admin User Id Role = 10, use original person's client id
        if(tmp_client_id != "&") client_id = tmp_client_id;

        //console.log("tmp_client_id: " + tmp_client_id);
        //console.log("2. client_id: " + client_id);
        handleGoToURL(e, that, "/document/edit/"+client_id+"/"+document_id);
        ///document/edit/${this.state.clientId}/${documents.id[i-1]
    }
    renderDocumentsList(documents) {

          var search_msg     = "";
          var tmp_search_msg = this.state.searchMsg;

          search_msg = <div key={uniqueId()} className="exerciseHeaderButtons">
                            <span style={{position:"relative", top:"7px", left:"7px", fonySize: "19px"}}>
                             { tmp_search_msg }
                            </span>

                            <span className="pull-right">
                                <SortDropdownClientDocument sortResults={this.sortResults.bind(this)} />
                            </span>
                       </div>

            if(documents != null) {
                  return [{}].concat(documents.file_name).map(
                    (document, i) =>
                      i !== 0 ?
                              <div key={uniqueId()} className="grid exerciseListGrid">
                                    <span className="clientListRowLeft">
                                            <span className="documentListSingleRowThumb">
                                                { getFiletypeIcon(documents.file_type[i-1], 40, 40) }
                                            </span>
                                    </span>
                                    <span   className="documentClientListAllRowMiddleLeft"
                                            onClick={(e) => this.handlePreURL(e, this, documents.id[i-1], documents.client_id[i-1])}>
                                          <span className="documentListNameSingleRow">
                                              { i + ". " + document}
                                          </span>
                                          <div>
                                              <span className="documentClientListAllMemberCol" >
                                                  Member: { documents.name[i-1] }
                                                  <span style={{display:"inline-block",paddingLeft:15}}/>
                                                  Created by: { documents.creator_name[i-1] }
                                              </span>
                                          </div>

                                              <span className="documentClientListAllDateFormat" >
                                                  <span className="documentListAllDateFormat">
                                                      Created: { (new Date(documents.date[i-1])).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) }

                                                  </span>
                                              </span>

                                    </span>
                                    <span className="clientListRowRight" style={{float:"right",zIndex:1000,backgroundColor: "transparent"}}>
                                            <span className="documentListDeleteCol pullRight"
                                                  onClick={(e) => this.handledeleteDocument(e, document, documents.document_id[i-1], documents.id[i-1], documents.client_id[i-1])}>
                                                <span className="glyphicon glyphicon-remove-circle glyphiconRemoveClientBtn"
                                                      style     = {{color:Colors.delete_button_bg}}/>
                                            </span>
                                    </span>
                            </div>

                            :
                            <span key={uniqueId()} >
                                <div className="exerciseHeaderSearchBar">
                                    <span>
                                        <FormGroup>
                                           <InputGroup>
                                             <FormControl key = {uniqueId()}
                                                          type="text"
                                                          placeholder=""
                                                          defaultValue={this.state.searchTerm}
                                                          inputRef={ref => { this.searchInput = ref; }}
                                                          onKeyPress={this.handleKeyPress}
                                                      />

                                               <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                                     onClick={() => this.clearSearchField()}
                                               />
                                               <InputGroup.Button>
                                                 <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }} onClick={() => this.searchDocuments()}>Search</Button>
                                               </InputGroup.Button>
                                           </InputGroup>
                                         </FormGroup>
                                  </span>
                              </div>
                              { search_msg }

                              { i === 0 && documents.file_name == "" ?
                                    <ListGroupItem style={{height:400}}>
                                        <br/>
                                    You currently have 0 documents.
                                    </ListGroupItem>

                                : null }
                          </span>
                  );
             }
    }

    handledeleteDocument = async (event, document_name, document_id, document_uid, client_id) => {
        event.preventDefault();
        var tmp_client_id = this.state.clientId;

        if(tmp_client_id != "&") client_id = tmp_client_id;

        this.setState({
            pageOverlay: "inline",
            showDeleteConfirmWin: true,
            clientIdDocToDelete: client_id,
            documentUid: document_uid,
            documentId: document_id,
            currentDocumentName: document_name
        });
    }

    getNext100Results = () => {
        var tmp_rows = this.state.numberOfRows;
        tmp_rows = tmp_rows + 100;

        this.setState({
            numberOfRows: tmp_rows
        }, function(){
            this.getDocumentList();
        })
    }

    renderPrograms() {
        var next_100;

        //if(!this.state.isLoading)
        //    next_100 = <span style={{display:"inline-block", width:"100%", textAlign:"center", fontSize:"18px", cursor:"pointer"}} onClick={() => this.getNext100Results()}>Next 100 results >></span>

        if(this.state.searchMsg != "") next_100 = ""; // if user is searching for a document, hide "next 100 results" msg

        return (
              <div className="programs">
                <PageHeader>
                        <span style={{width:"220px"}}>
                            <FontAwesomeIcon icon="file-signature" style={{ position:"relative", top:6, fontSize: '1.4em', color: Colors.primary_color, paddingRight:"16px" }}/>
                             Documents: All Members
                        </span>
                        <span className = "pull-right"
                              style     = {{ position:"relative", top:9, right: 16}}>
                            <Button className = "btnClientAddNew"
                                    onClick={(e) => handleGoToURL(e, this, `/document/new/${this.state.clientId}/&`)}>
                                Add New
                            </Button>
                        </span>
                </PageHeader>

                <ListGroup style={{display: "inline-block"}}>
                    {!this.state.isLoading && this.renderDocumentsList(this.state.documents)}
                </ListGroup>
                { next_100 }
                <br/><br/><br/><br/>
              </div>
        );
    }

    async deleteDocument () {
        this.setState({
            isLoading: true,
            //showDeleteConfirmWin: true,
            loadingData: "Deleting document ... ",
            //showLoadingBar: "inline"
        });

        // Step 1. Delete Source File from AWS S3
        const resultsDeleteFile = await s3Delete(this.state.documentId); // delete actual file from S3

        if(resultsDeleteFile.status) {
            var client_id = this.state.clientIdDocToDelete;
            console.log("this.state.clientId " + client_id);
            console.log("this.state.documentUid " + this.state.documentUid);
            // Step 2. Delete File Data from Database
            const resultsDeleteDBData = await invokeSetDeleteDocument(client_id, this.state.documentUid);

            if(resultsDeleteDBData.status) {
                this.getDocumentList();
            } else this.getDocumentList();
        } else
            this.getDocumentList();
    }

    handleCloseWin = (action) => {
        if(action === "delete") this.deleteDocument();
            else this.setState({ pageOverlay: "none", showDeleteConfirmWin: false });
    }

    render() {
        let closeModalAlert        = () => this.setState({ showModalAlert: false }); //close simple modal window
        return (
              <div className="ProgramList">
                {this.props.isAuthenticated ? this.renderPrograms() : <RenderLander />}

                <FooterLoadingBar text={"Retieving Documents ..."}
                                  showLoadingBar={this.state.showLoadingBar}/>

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
                  <div>
                        <span className="pageOVerlay" style={{display:this.state.pageOverlay}}></span>
                        <Modal
                               show={this.state.showDeleteConfirmWin}
                               onHide={() => this.handleCloseWin("close")}
                               size            = "lg"
                               centered        = "true"
                               aria-labelledby = "contained-modal-title"
                               className       = "modalBasics"
                             >
                               <Modal.Header closeButton>
                                 <Modal.Title id="contained-modal-title">
                                     <FontAwesomeIcon icon="info-circle" className="modalAlertIcon" />
                                     <span className="modalBasicsTitle">
                                         Confirm Document Deletion
                                     </span>
                                 </Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                    <span className="modalAlertBody">
                                       Are you sure you want to delete "<span style={{fontWeight:"bold"}}>{ this.state.currentDocumentName }</span>" PERMANENTLY?
                                    </span>
                               </Modal.Body>
                               <Modal.Footer>
                                   <Button className="modalBasicsBtnClose" onClick={() => this.handleCloseWin("close")}>Cancel</Button>
                                   <span className="modalBasicsFooterXPosSpacer"/>
                                   <LoaderButton
                                       bsSize    = "large"
                                       //disabled  = {!this.validateForm()}
                                       //type      = "submit"
                                       btncolor    = { Colors.delete_button_dark_red_bg }
                                       height    = {38}
                                       width     = {125}
                                       isLoading = {this.state.isLoading}
                                       text        = "Yes, Delete"
                                       loadingText = "" //"Deleting program…"
                                       onClick     = {() => this.handleCloseWin("delete")}
                                     />
                               </Modal.Footer>
                         </Modal>
                  </div>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/document/DocumentClientListAll.js